import { BANNER_TYPES, ROLE_TYPES } from '../../../common/constants';
import EnablementFormNotification from '../EnablementFormNotification/EnablementFormNotification';
import DhhFreezeModeNotification from '../FreezeModeNotification/DhhFreezeModeNotification';
import ExtensionFreezeModeNotification from '../FreezeModeNotification/ExtensionFreezeModeNotification';
import DeprecationBanner, { isDeprecatedState } from '../DeprecationBanner/DeprecationBanner';
import { checkProvision, getPropertyType } from '../../../redux/store/store-helper';
import { PROVISIONS } from '../../../common/enums';

export const getAppNotification = (state) => {
  const { profile, app } = state;

  if (!profile || !profile.provisioning) {
    return null;
  }

  if (profile.freezeMode) {
    return buildFreezeModeBanner(profile);
  }

  if (isDeprecatedState(app && app.currentPage)) {
    return {
      component: DeprecationBanner,
      type: BANNER_TYPES.ANNOUNCEMENT,
    };
  }

  return buildV2UpgradeBanner(profile);
};

function buildFreezeModeBanner({ provisioning }) {
  return {
    component: provisioning[DigProvisions.EXTENSION_ENABLED] ? ExtensionFreezeModeNotification : DhhFreezeModeNotification,
    type: BANNER_TYPES.WARNING,
  };
}

function buildV2UpgradeBanner({ userRole }) {
  const isFormV2Provisioned = checkProvision(PROVISIONS.FORM_V2);
  const isAppropriateRole = [ROLE_TYPES.ROLE_ADMIN, ROLE_TYPES.SUPER_ADMIN].includes(userRole);
  const propertyType = getPropertyType();
  const isAnywhereProperty = propertyType === 'anywhere';

  const isShowUpgradeNotification = !isFormV2Provisioned && isAppropriateRole && !isAnywhereProperty;

  return isShowUpgradeNotification ? {
    component: EnablementFormNotification,
    type: BANNER_TYPES.ANNOUNCEMENT,
  } : null;
}
